'use client';

import { useAuth } from '../../../contexts/AuthContext';

interface ChatBoxIconProps {
    onOpenChatDlg: () => void;
}

export default function ChatBoxIcon({ onOpenChatDlg }: ChatBoxIconProps) {
    const { fetchChatInfos } = useAuth();

    return (
        <div onClick={() => { onOpenChatDlg(); fetchChatInfos(); }} className="bg-slate-800/50 backdrop-blur-xl rounded-2xl p-6 border border-purple-500/20 text-center hover:shadow-lg hover:shadow-purple-500/20 transition-all duration-300">
            <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-chat-smile-3-line text-blue-400 text-2xl"></i>
            </div>
            <h3 className="font-semibold text-white mb-2">Live Chat</h3>
            <p className="text-sm text-slate-300">Avg. response time 2 min</p>
        </div>
    );
}